/**
 * Represents the response structure for meal break status.
 */
export class MealBreakStatusResponse {
  /**
   * @param {Object} data - The raw JSON data.
   * @param {Object} data.form - The form object.
   */
  constructor(data = {}) {
    /**
     * @type {MealBreakForm}
     * @description Instance of Form containing reduced meal break information.
     */
    this.form = data.form ? new MealBreakForm(data.form) : null
  }

  /**
   * Checks if the form property is set, signaling that the UI should
   * render a form.
   * @returns {boolean} True if the option exists, false otherwise.
   */
  shouldRenderForm() {
    return !!this.form
  }
}

/**
 * Represents the form data in the meal break status response.
 */
export class MealBreakForm {
  /**
   * @param {Object} formData - The form data object.
   * @param {Object} formData.reducedMealBreak - The reduced meal break data.
   */
  constructor(formData = {}) {
    /**
     * @type {ReducedMealBreakInputModel}
     * @description Instance of ReducedMealBreakInputModel containing options.
     */
    this.reducedMealBreak = new ReducedMealBreakInputModel(
      formData?.reducedMealBreak?.options || []
    )
  }
}

/**
 * Represents the reduced meal break options.
 */
export class ReducedMealBreakInputModel {
  /**
   * @param {string[]} options - The list of reasons for reduced meal breaks.
   */
  constructor(options = []) {
    /**
     * @type {string[]}
     * @description List of available options for reduced meal breaks.
     */
    this.options = options
  }

  /**
   * Gets all available options.
   * @returns {string[]} The list of options.
   */
  getOptions() {
    return this.options
  }

  /**
   * Checks if a specific option is available.
   * @param {string} option - The option to check.
   * @returns {boolean} True if the option exists, false otherwise.
   */
  hasOption(option) {
    return this.options.includes(option)
  }
}
